import MasterLayout from "../otherImages/MasterLayout";
import ThankyouDetail from "../components/ThankyouDetail";

const ManageInvoices = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* <DefaultTopBar
            title="Manage Orders"
        /> */}

        {/* TableDataLayer */}
        <ThankyouDetail />

      </MasterLayout>

    </>
  );
};

export default ManageInvoices; 
